/**
 * /dashboard/settings/zoho — Zoho Books integration setup
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { ZohoConnectionCard } from '@/components/zoho/ZohoConnectionCard';
import { ZohoSyncCard } from '@/components/zoho/ZohoSyncCard';
import { ZohoCategoryMappingCard } from '@/components/zoho/ZohoCategoryMappingCard';
import { ArrowLeft } from 'lucide-react';

export default function ZohoSettingsPage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  const allowedRoles = ['super_admin', 'admin', 'accountant'];
  const userRole = user?.role ?? '';
  if (!allowedRoles.includes(userRole)) {
    return (
      <div className="container mx-auto p-6">
        <div className="rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          {t('zoho.no_permission', 'You don\'t have permission to view this page.')}
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6 max-w-4xl space-y-6">
      <div>
        <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-3">
          <ArrowLeft className="h-4 w-4" />
          {t('back', 'Back')}
        </Link>
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('zoho.title', 'Zoho Books integration')}
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t('zoho.subtitle', 'Connect Jasr Hub to your Zoho Books account for bidirectional accounting sync.')}
        </p>
      </div>

      <ZohoConnectionCard />
      <ZohoSyncCard />
      <ZohoCategoryMappingCard />
    </div>
  );
}
